<template>
  <div class="yingyong" v-if="list && list.length">
      <div class="inner">
        <div class="pub-title">
          <span>{{ $t('zgzb') }}</span>
        </div>
        <div class="content">
          <div class="item item1" v-for="(item, index) in list" :key="index" @click="openDetail(item)">
              <img class="img" :src="item.coverImgUrl" alt="">
              <div class="text">
                <div class="title ellipsis2">{{ item['name' + En] }}</div>
                <!-- <div class="addr">
                  <div class="addr-item">
                    <img src="https://static.worldaic.com.cn/2024/web/static/images/clock.png" alt="">
                    <span>{{ item.releaseTime }}</span>
                  </div>
                  <div class="addr-item">
                    <img src="https://static.worldaic.com.cn/2024/web/static/images/addr.png" alt="">
                    <span>{{ item['addr' + En] }}</span>
                  </div>
                </div> -->
              </div>
            </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          :page-size="6"
          :layout="pageLayout"
          :pager-count="isPc ? 7 : 3"
          :total="total">
        </el-pagination>
      </div>
      <zgzbDialog
        :showModal.sync="showModal"
        :uuid.sync="uuid"
      ></zgzbDialog>
  </div>
</template>

<script>
import protal from "@/api/protal";
import zgzbDialog from "@/components/zgzbDialog.vue";

export default {
  components: {
    zgzbDialog
  },
  name: 'yingyong',
  data() {
    return {
      list: [],
      currentPage: 0,
      pageNum: 1,
      total: 0,
      showModal: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    handleCurrentChange(v) {
      this.pageNum = v
      this.getData()
    },
    getData() {
      const params = {
        "pageNum": this.pageNum,
        "pageSize": 6,
      }
      protal.queryTreasureZhenGuanList(params).then(res => {
        this.list = res.data || []
        this.total = res.total || 0
      })
    },
    openDetail(item) {
      this.showModal = true
      this.uuid = item.uuid
    }
  }
}
</script>

<style lang="less" scoped>
  .yingyong {
    background: none;
    padding-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/zhanqu/zgzb.vue